import auth from '@/Middlewares/auth.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'

export const roleRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('roles', {
      edit: () => import(/* webpackChunkName: "admin" */ './Pages/Edit.vue'),
      list: () => import(/* webpackChunkName: "admin" */ './Pages/List.vue'),
      create: () =>
        import(/* webpackChunkName: "admin" */ './Pages/Create.vue'),
    })
      .permissions({
        edit: 'roles.update',
        list: 'roles.view',
        create: 'roles.create',
      })
      .meta({
        edit: { back: 'roles.list' },
        list: { back: 'roles.list' },
        create: { back: 'roles.list' },
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
